import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared/shared.module';

import { InputTextComponent } from './components/input-text/input-text.component';
import { InputNumberComponent } from './components/input-number/input-number.component';
import { JobTitlesComponent } from './components/job-titles/job-titles.component';
import { CustomEditorComponent } from './components/custom-editor/custom-editor.component';


export class InlineEditModule { }



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/shared/inline-edit/inline-edit.module.ts